<!-- 工业企业详情 -->
<template>
  <div class="dialog-enterprise">
    <div class="header">
      <div class="title f-size-24 f-col-white08">{{ data.wrymc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content left" :class="show ? '' : 'info'">
        <div class="descriptions-item">
          <span class="key">联系人：</span>
          <span class="value">{{ data.lxrxm || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">联系电话：</span>
          <span class="value">{{ data.lxrdh || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">污染源名称：</span>
          <span class="value">{{ data.wrymc || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">社会信用服务码：</span>
          <span class="value">{{ data.tyshxydm || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">许可证号：</span>
          <span class="value">{{ data.pwxkzdm || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">受纳水体：</span>
          <span class="value">{{ data.snst || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">企业规模：</span>
          <span class="value">{{ data.qygm || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">详细地址：</span>
          <span class="value">{{ data.xxd || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">组织机构代码：</span>
          <span class="value">{{ data.zzkgdm || '-' }}</span>
        </div>
        <div v-if="show" class="descriptions-item video">
          <div class="video"></div>
        </div>
      </div>
      <div v-if="show" class="content right">
        <div class="row">
          <div class="select">
            <div class="key">排口：</div>
            <n-select v-model:value="value" size="small" :options="options" />
          </div>
          <div class="select">
            <div class="key">监测因子：</div>
            <n-select v-model:value="value" size="small" :options="options" />
          </div>
        </div>
        <div class="row select">
          <div class="key">时间：</div>
          <n-time-picker v-model:value="timestamp" size="small" />
          <span class="line">--</span>
          <n-time-picker v-model:value="timestamp" size="small" />
        </div>
        <div class="row point">
          <div class="key">超标因子及百分比：</div>
          <div class="value">{{ cbyz }}</div>
        </div>
        <div class="echart">
          <div class="row">
            <div class="echart-btn" :class="{ active: selectEchart === '时均值' }" @click="select('时均值')">
              时均值
            </div>
            <div class="echart-btn" :class="{ active: selectEchart === '日均值' }" @click="select('日均值')">
              日均值
            </div>
          </div>
          <div id="echart-enterprise" class="echart-dom" ref="enterpriseChart"></div>
        </div>
      </div>
    </div>
    <div v-if="videoList && videoList.length > 0">
      <n-select style="width: 200px;margin-bottom: 10px;" v-if="videoList" v-model:value="active" size="small"
        :options="videoList" @update:value="changeVideo" />
      <div ref="videoContainer" class="video-box"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted, onBeforeUnmount, ref, markRaw } from 'vue'
import * as echarts from 'echarts'
import Video from 'video.js'
import { Api } from '@/api/publicApi'

const api = new Api()
const props = defineProps({
  data: Object,
})

const active = ref(null)

const videoContainer = ref()
const video = ref()
const videoList: any = ref([])
let customInterval = null
let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}


const myChart = ref<any>(null)
const enterpriseChart = ref<any>(null)
const { data } = toRefs(props)
const selectEchart = ref('时均值')
const cbyz = ref('无')
// const { proxy } = getCurrentInstance()
let instance: any = null
const show = ref(false)
const testX = [
  '2022-01-25 05',
  '2022-01-25 06',
  '2022-01-25 07',
  '2022-01-25 08',
  '2022-01-25 09',
  '2022-01-25 10',
  '2022-01-25 11',
  '2022-01-25 12',
]
const testY = [0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4]
const initChart = (xdata = testX, ydata = testY) => {
  // const dom = document.getElementById('echart-enterprise')
  // console.log("dom 结构",dom)
  if (myChart.value) {
    myChart.value.clear()
  }
  // instance = proxy.$echarts.init(dom)

  const charts = {
    unit: '',
    lineX: xdata,
    value: ydata,
  }
  const option = {
    title: {
      show: false,
    },
    tooltip: {
      trigger: 'item',
    },
    grid: {
      left: '0%',
      right: '12%',
      bottom: '0%',
      top: '10%',
      containLabel: true,
    },
    xAxis: {
      name: '时间',
      data: xdata,
      nameTextStyle: {
        fontSize: 12,
      },
      boundaryGap: false,
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#BAE7FF',
        },
      },

      axisLabel: {
        type: 'category',
        formatter: '{value}',
        margin: 20,
        textStyle: {
          fontSize: 12,
          color: '#8EC0CE',
        },
      },
    },
    yAxis: {
      show: true,
      type: 'value',
      min: 0,
      max: 1,
      splitLine: {
        show: true,
        lineStyle: {
          width: 2,
          dashOffset: 10,
          type: 'dashed',
          color: 'rgba(230, 247, 255, 0.2)',
        },
      },
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          fontSize: 14,
          color: '#8EC0CE',
        },
      },
    },
    dataZoom: [
      {
        type: 'inside',
        start: 10,
        end: 100,
      },
    ],
    series: [
      {
        name: '',
        type: 'line',
        color: '#09CEA5',
        smooth: false, // 关键点，为true是不支持虚线，实线就用true
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2,
              type: 'dotted', // 'dotted'虚线 'solid'实线
            },
          },
        },
        lineWidth: 6,
        symbol: '',
        symbolSize: 12,
        markLine: {
          // 标准线
          symbol: 'triangle',
          symbolSize: 12,
          symbolOffset: [0, [0, -10]],
          silent: true,
          lineStyle: {
            color: '#FFD225',
            width: 2,
          },
          label: {
            color: '#FFD225',
            fontSize: 14,
          },
          data: [
            {
              yAxis: 0.8,
              label: {
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            }, // 最大值水平线或垂直线
          ],
        },
        data: ydata,
      },
    ],
  }
}

const changeVideo = (deviceId) => {
  nextTick(() => {
    api.screen.getCameraStreamListByIdUsingPost({
      id: deviceId,
    })
      .then((res) => {
        let url = ''
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].deviceId === deviceId) {
            url = res.data[i].videoStream
            break
          }
        }
        player.src({
          type: '',
          src: url,
        })
        player.play()
      })
  })
}
onMounted(() => {
  console.log("啊啊啊", enterpriseChart.value)
  if (enterpriseChart.value) {
    myChart.value = markRaw(echarts.init(enterpriseChart.value));
  }
  if (player) {
    player.dispose()
  }
  videoList.value = []
  if (data.value.videoPoints && data.value.videoPoints.length > 0) {
    active.value = data.value.videoPoints[0].videoDeviceCode
    for (let i = 0; i < data.value.videoPoints.length; i++) {
      videoList.value.push(
        {
          label: data.value.videoPoints[i].videoDeviceName,
          value: data.value.videoPoints[i].videoDeviceCode
        },
      )
    }
    nextTick(() => {
      const video = document.createElement('video');
      video.setAttribute('style', 'width: 100%; height: 100%');
      video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
      video.setAttribute('id', 'pop_video');
      videoContainer.value.appendChild(video);
      setTimeout(() => {
        const option = {
          muted: false,
          controls: true,
          loop: false,
          autoplay: false,
          sources: [],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          // poster:,
          // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
        }
        // 初始化的时候标签默认都是显示的
        player = Video('pop_video', option, () => {
          player.on('error', () => {
            player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
            console.log('视频加载错误')
          })
        })
        changeVideo(videoList.value[0].value)
      }, 1000)
    })
  }
})

onBeforeUnmount(async () => {
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})
</script>

<style lang="scss" scoped>
.dialog-enterprise {
  width: 64rem;
  min-width: 64rem;

  .header {
    text-align: left;
    margin-bottom: 2rem;

    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
  }

  .body {
    display: flex;

    .content {
      margin-bottom: 2rem;

      &.left {
        width: 40%;
        margin-right: 0.5rem;
      }

      &.right {
        width: 60%;
      }

      .descriptions-item {
        width: 100%;
        line-height: 2.65rem;
        margin-bottom: 0.5rem;
        display: flex;
        align-items: flex-end;
        text-align: left;
        align-items: baseline;

        &:last-of-type {
          margin-bottom: 1.4rem;
        }

        .key {
          color: #fff;
          min-width: 8.3rem;
          margin-right: 1.9rem;
          text-align: left;
          text-align-last: justify;
        }

        .video {
          width: 15.5rem;
          height: 15.5rem;
          background-color: #fff;
          margin: 0 auto;
          margin-top: 2rem;
        }
      }

      .row {
        display: flex;
        margin-bottom: 2rem;

        .line {
          margin: 0 0.5rem;
        }

        .select {
          width: 50%;
          display: flex;

          .key {
            font-size: 12px;
            white-space: nowrap;
            line-height: 28px;
            height: 28px;
          }

          ::v-deep .n-select {

            .n-base-selection-label,
            .n-base-selection__border,
            .n-base-selection__state-border {
              width: 12rem;
              height: 2.4rem;
            }
          }
        }
      }

      .echart {
        .echart-btn {
          width: 5.6rem;
          height: 2.4rem;
          line-height: 2.4rem;
          background: #0088bf;
          border: 0.025rem solid #fff;
          border-radius: 0.1rem;
          text-align: center;
          cursor: pointer;
          display: inline-block;

          &.active {
            background: #fff;
            border: 0.025rem solid #fff;
            color: #0088bf;
          }
        }

        .echart-dom {
          width: 36.75rem;
          height: 30rem;
          margin: 0 auto;
        }
      }
    }

    .content.info {
      width: 100%;

      .descriptions-item {
        display: inline-block;
        width: 50%;
      }
    }
  }

  .video-box {
    width: 63.9rem;
    height: 50rem;

    #play_window {
      width: 100%;
      height: 100%;
    }

    .video {
      width: 100%;
      height: 100%;

      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
